import type { Voucher } from '@src/domains/vouchers/types/voucher';
import { isVoucherPending } from '@src/domains/vouchers/core/isVoucherPending';

export function isVoucherDownloadable(voucher: Voucher): boolean {
  return !voucher.revokedAt && !isVoucherPending(voucher);
}
